import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import ForecastOnBoardingDocumentContent from "./ForecastOnBoardingDocumentContent/ForecastOnBoardingDocumentContent.js";
import ForecastOnBoardingDocumentCoordinator from "./ForecastOnBoardingDocumentCoordinator.js";
import ForecastOnBoardingDocumentService from "./ForecastOnBoardingDocumentService.js";
import ForecastOnBoardingDocumentState from "./ForecastOnBoardingDocumentState.js";
import session from "../../core/session.js";
import TitleWidget from "../../core/chrome/TitleWidget2.js";

/**
 * Glue together all the parts for creating a Forecast on-boarding document.
 */
export default function makeForecastOnBoardingDocument() {
	const coordinator = new ForecastOnBoardingDocumentCoordinator({
		documentState: new ForecastOnBoardingDocumentState({
			service: new ForecastOnBoardingDocumentService({ session }),
		}),
		renderables: {
			content: new ForecastOnBoardingDocumentContent(),
			periodPicker: false,
			title: new TitleWidget({
				title: _("Forecast OnBoarding"),
			}),
		},
	});

	return new AccountingDocument({
		coordinator,
		cssClass: "forecast-onboarding full-page",
	});
}
